<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/auth`;
const authService = {
  async login(formRaw) {
    try {
      const form = { ...formRaw };
      console.log(apiUrl);
      const response = await axios.post(`${apiUrl}/login`, form, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return utilsService.setLogin(response.data.token);
    } catch (error) {

      console.error('Error al enviar el formulario', error);
    }
  },
  async register(formRaw) {
    try {
      const form = { ...formRaw };
      
      const response = await axios.post(`${apiUrl}/register`, form, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al registrar.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },
  async resetPassword(payload) {
    try {
      const response = await axios.post(`${apiUrl}/reset-password`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al restablecer la contraseña.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },
  async requestPasswordReset(email) {
    try {
      const lang = localStorage.getItem('language') || 'es';
      const response = await axios.post(`${apiUrl}/forgot-password`, { email, lang }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al solicitar recuperación.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  }
};

export default authService;
</script>
